import Payin from "./reportIcons/payin.png";
import Settlement from "./reportIcons/settlement.png";
import ChargeBack from "./reportIcons/chargeback.png";
import Myvendors from "./reportIcons/vendor.png";
import Payout from "./reportIcons/payout.png";
import Withdraw from "./reportIcons/withdraw.png";
import Ekyc from "./reportIcons/e-kyc.png";
import Ledger from "./reportIcons/ledger.png";
import Guarantee from "./reportIcons/guarantee.png";
import Reconcilation from "./reportIcons/Reconcilation.png";
import CreditBalance from "./reportIcons/credit_balance.png";
import Release from "./reportIcons/release.png";
import WalletBalance from "./reportIcons/wallet_balance.png";
import Hold from "./reportIcons/hold.png";
import Deposit from "./reportIcons/deposit.png";
import SettlementAdjustment from "./reportIcons/settlement_adjustment.png";
import Archived from "./reportIcons/archived.png";
import PayoutTxnCallBack from "./tools/tools/payout_txn_cb.png";
import toolPayout from "./tools/tools/payout.png";
import RegisterVendor from "./tools/tools/register_vendor.png";
import TransactionStatus from "./tools/tools/txn_st.png";
import TransactionCallback from "./tools/tools/txnCallback.png";
import Vendor from "./tools/tools/vendor (2).png";
import Wallet from "./tools/tools/wallet.png";
import toolWithdraw from "./tools/tools/withdraw.png";
import MerchantDetails from "./tools/tools/MerchantDtls.png";
import HoldDepo from "./tools/tools/holddepo.png";
import PayinRouting from "./tools/tools/payinrouting.png";
import eKYC from "./tools/tools/ekyc.png";
import FlagManagement from "./tools/tools/flagmanagement.png";
import FraudManagement from "./tools/tools/fraudmanagement.png";
import MDR from "./tools/tools/MDR.png";
import uploadChargeback from "./tools/tools/uploadchargeback.png";
import reconciliationTools from "./tools/tools/reconciliation.png";
import pendingpayout from "./tools/tools/pendingpayout.png";
import pendingvendor from "./tools/tools/pendingvendor.png";
import callbackapitest from "./tools/tools/callback test.png";
import MerchantTransaction from "./reportIcons/merchant transaction.png";
import payoutApiTest from "./tools/tools/payoutAPITest.png";
import SIDSubmitted from "./MastersIcon/MastersIcon/SIDSubmitted.png";
import createSidImage from "./MastersIcon/MastersIcon/createSidImage.png";
import SIDDetails from "./MastersIcon/MastersIcon/SIDDetails.png";
import BBPSMaster from "./MastersIcon/MastersIcon/BBPSMaster.png";
import Onboarding from "./MastersIcon/MastersIcon/Onboarding.png";
import MastersForm from "./MastersIcon/MastersIcon/MastersForm.png";
import AdmingroupImage from "./tools/tools/Admingroup.png";
import Billing from "./tools/tools/Billing.png";
import MerchantPanel from "./tools/tools/MerchantPanel.png";
import UserPng from "./tools/tools/User.png";
import Application from "./OnboardingIcon/OnboardingIcon/Application.png";
import OnBoarding from "../../Components/CustomerSupport/OnBoarding";
import payinrouting from "./OnboardingIcon/OnboardingIcon/payinrouting.png";
import payout from "./OnboardingIcon/OnboardingIcon/payout.png";
import ekyc from "./OnboardingIcon/OnboardingIcon/ekyc.png";
import voucher from "./OnboardingIcon/OnboardingIcon/voucher.png";
import trap from "./OnboardingIcon/OnboardingIcon/trap.png";
import userManagement from "./tools/tools/userManagement.png";
import routingRules from "./tools/tools/routingRules.png";
import ViewUTR from "../images/reportIcons/view_utr.png";
import mobileAppOnboard from "./OnboardingIcon/OnboardingIcon/mobileapponboard.jpg";
import IPManagementIcon from "../images/tools/tools/ip-management.png";

import UpiIcon from "../images/serviceicons/outgoing-call_11777203.png";
import QrIcon from "../images/serviceicons/qr-code_3409588.png";
import mAtmIcon from "../images/serviceicons/machine_16370798.png";
import DpcIcon from "../images/serviceicons/monitor_1053982.png";
import PosIcon from "../images/serviceicons/pos.png.png";
import PayoutIcon from "../images/serviceicons/payout.png.png";
import DmtIcon from "../images/serviceicons/dmt.png";
import AepsIcon from "../images/serviceicons/aeps.png";
import IpgIcon from "../images/serviceicons/ipg_17055874.png";
import NetBankingIcon from "../images/serviceicons/netbanking.png";
import RemittanceIcon from "../images/serviceicons/remitance.png";
import SoftPosIcon from "../images/serviceicons/softpos.png";
import Virtual_TerminalIcon from "../images/serviceicons/virtualterminnal.png";

export const reporticons = {
  Payin,
  Settlement,
  ChargeBack,
  Myvendors,
  Payout,
  Withdraw,
  Ekyc,
  Guarantee,
  Reconcilation,
  CreditBalance,
  Release,
  WalletBalance,
  Hold,
  Deposit,
  SettlementAdjustment,
  Ledger,
  Archived,
  MerchantTransaction,
  ViewUTR,
};
export const toolIcons = {
  PayoutTxnCallBack,
  AdmingroupImage,
  MerchantPanel,
  UserPng,
  toolPayout,
  RegisterVendor,
  TransactionStatus,
  TransactionCallback,
  Vendor,
  Wallet,
  Billing,
  toolWithdraw,
  MerchantDetails,
  HoldDepo,
  PayinRouting,
  eKYC,
  FlagManagement,
  FraudManagement,
  MDR,
  uploadChargeback,
  reconciliationTools,
  pendingpayout,
  pendingvendor,
  callbackapitest,
  payoutApiTest,
  userManagement,
  routingRules,
  BBPSMaster,
  IPManagementIcon
};

export const MastersIcons = {
  SIDSubmitted,
  SIDDetails,
  Onboarding,
  MastersForm,
  BBPSMaster,
  createSidImage,
};

export const OnBoardingIcons = {
  Application,
  payinrouting,
  payout,
  ekyc,
  voucher,
  trap,
  mobileAppOnboard,
};

export const ServiceIcons = {
  UPI: UpiIcon,
  QR: QrIcon,
  mATM: mAtmIcon,
  DPC: DpcIcon,
  POS: PosIcon,
  PAYOUT: PayoutIcon,
  DMT: DmtIcon,
  AEPS: AepsIcon,
  IPG: IpgIcon,
  NET_BANKING: NetBankingIcon,
  REMITTANCE: RemittanceIcon,
  SOFTPOS: SoftPosIcon,
  "VIRTUAL TERMINAL": Virtual_TerminalIcon,
  eKYC: ekyc,
  "ACCOUNT WITHDRAWL": toolWithdraw,
};
